const s = "_container_1sdob_1", e = "_hasFiles_1sdob_11", o = "_disabled_1sdob_22", l = "_focusMode_1sdob_29", a = "_isError_1sdob_33", i = "_fullSize_1sdob_36", _ = "_fullSizeFocused_1sdob_44", d = "_fullSizeHasFiles_1sdob_48", c = "_containerFilesArea_1sdob_83", n = "_coloredHeading_1sdob_91", t = "_downloadTemplateButton_1sdob_94", r = "_accessibilityWrapper_1sdob_98", u = {
  container: s,
  hasFiles: e,
  disabled: o,
  focusMode: l,
  isError: a,
  fullSize: i,
  fullSizeFocused: _,
  fullSizeHasFiles: d,
  "upload-area": "_upload-area_1sdob_58",
  "files-area": "_files-area_1sdob_71",
  containerFilesArea: c,
  coloredHeading: n,
  downloadTemplateButton: t,
  accessibilityWrapper: r
};
export {
  r as accessibilityWrapper,
  n as coloredHeading,
  s as container,
  c as containerFilesArea,
  u as default,
  o as disabled,
  t as downloadTemplateButton,
  l as focusMode,
  i as fullSize,
  _ as fullSizeFocused,
  d as fullSizeHasFiles,
  e as hasFiles,
  a as isError
};
//# sourceMappingURL=index.es734.js.map
